import {DAY_MS, iso, makeShareToken, country, EUROPE_COUNTRIES, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

const NORTH_AMERICA_COUNTRIES = [country("US", "United States"), country("CA", "Canada")];
const JAPAN_COUNTRIES = [country("JP", "Japan")];

// "Package queue" demo: installed, healthy active Europe pack, with two more
// packages already purchased and waiting on the same eSIM - they only need
// to render as "up next", never as active, so they're built unactivated
// (activatedAt: null) and excluded from activeBalance by that same check.
function dates() {
    return {
        activatedAt: iso(-5 * DAY_MS),
        expiresAt: iso(-5 * DAY_MS + 30 * DAY_MS),
        salesDate: iso(-5 * DAY_MS - 60 * 60 * 1000)
    };
}

function queuedBalances() {
    return [
        {
            price: {priceValue: 24.99, currencyCode: "USD"},
            salesDate: iso(-5 * DAY_MS - 60 * 60 * 1000),
            customerProfileDomainId: MOCK_DOMAIN_ID,
            includedCountries: NORTH_AMERICA_COUNTRIES,
            balance: {
                name: "USA & Canada Pack",
                activatedAt: null,
                expiresAt: iso(30 * DAY_MS),
                activationMode: "ON_DEMAND",
                size: {sizeValue: 20, sizeUnit: "GB"},
                availableBalance: {sizeValue: 20, sizeUnit: "GB"},
                validitySize: 30, validityUnit: "days",
                countrySet: "noa",
                extendedDataPolicy: null
            }
        },
        {
            price: {priceValue: 12.99, currencyCode: "USD"},
            salesDate: iso(-3 * DAY_MS),
            customerProfileDomainId: MOCK_DOMAIN_ID,
            includedCountries: JAPAN_COUNTRIES,
            balance: {
                name: "Japan Data Pack",
                activatedAt: null,
                expiresAt: iso(15 * DAY_MS),
                activationMode: "ON_DEMAND",
                size: {sizeValue: 5, sizeUnit: "GB"},
                availableBalance: {sizeValue: 5, sizeUnit: "GB"},
                validitySize: 15, validityUnit: "days",
                countrySet: "jp",
                extendedDataPolicy: null
            }
        }
    ];
}

export function getMockCustomerProfile() {
    const {activatedAt, expiresAt, salesDate} = dates();

    return {
        totalAvailableBalance: {sizeValue: 3.1, sizeUnit: "GB"},
        balances: [
            {
                price: {priceValue: 14.99, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: EUROPE_COUNTRIES,
                balance: {
                    name: "Europe Data Pack",
                    activatedAt,
                    expiresAt,
                    activationMode: "NOW",
                    size: {sizeValue: 10, sizeUnit: "GB"},
                    availableBalance: {sizeValue: 3.1, sizeUnit: "GB"},
                    validitySize: 30, validityUnit: "days",
                    countrySet: "eur",
                    extendedDataPolicy: null
                }
            },
            ...queuedBalances()
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Installed",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt,
                lastSeen: iso(-30 * 60 * 1000),
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

export function getMockEsimData() {
    const {activatedAt, expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Installed",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt,
            lastSeen: iso(-30 * 60 * 1000),
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "Europe Data Pack",
                activatedAt,
                expiresAt,
                activationMode: "NOW",
                size: {sizeValue: 10, sizeUnit: "GB"},
                availableBalance: {sizeValue: 3.1, sizeUnit: "GB"},
                validitySize: 30, validityUnit: "days",
                countrySet: "eur",
                extendedDataPolicy: null
            },
            ...queuedBalances().map((b: {balance: unknown}) => b.balance)
        ],
        totalAvailableBalance: {sizeValue: 3.1, sizeUnit: "GB"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
